<template>
    <div class="container">
        <a-card>
            <a-alert message="推流配置" type="info">
                <template #description>
                    <a-button type="primary" @click="onUploadKey" :disabled="config.upstream > 0"
                        style="float:right;">更新推流密钥</a-button>
                    <div v-clipboard:copy="config.stream_push_url" v-clipboard:success="onCopy"> <b>推流地址:</b>
                        {{ config.stream_push_url }}
                        <a-icon type="copy" /> 复制
                    </div>
                    <div v-clipboard:copy="config.stream_push_id" v-clipboard:success="onCopy"> <b>推流密钥:</b>
                        {{ config.stream_push_id }}
                        <a-icon type="copy" /> 复制
                    </div>
                </template>
            </a-alert>
            <a-row style="padding-top: 20px" v-if="false">
                <a-col :span="12">
                    <a-form-model layout="inline">
                        <p>封面图只允许上传小于4M的图片(比例：16:9 格式：jpg/jpeg/png)</p>
                        <a-form-model-item label="封面图">
                            <a-upload list-type="picture-card" :file-list="liveBannerList"
                                accept="image/jpg,image/jpeg,image/png,image/PNG" @beforeUpload="beforeUpload"
                                @preview="handlePreview" :customRequest="imgUpload" :remove="imgRemove"
                                @change="fileChange">
                                <div v-if="liveBannerList.length < 1">
                                    <a-icon type="plus" />
                                    <div class="ant-upload-text">
                                        Upload
                                    </div>
                                </div>
                            </a-upload>
                        </a-form-model-item>
                        <a-form-model-item>
                            <a-button type="primary" @click="onSaveLiveBanner" :loading="livebanner.loading">
                                保存
                            </a-button>
                        </a-form-model-item>
                    </a-form-model>
                </a-col>
            </a-row>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                <div style="padding: 20px;">
                    <img alt="example" style="width: 100%" :src="previewImage" />
                </div>
            </a-modal>

            <a-divider></a-divider>
            <a-form-model :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }" style="margin-top:16px">
                <a-form-model-item label="赛事类型">
                    <a-radio-group v-model="query.type" @change="onSearch" button-style="solid">
                        <a-radio-button :value="0">
                            足球
                        </a-radio-button>
                        <a-radio-button :value="1">
                            篮球
                        </a-radio-button>
                        <!-- <a-radio-button :value="8">
                            电竞
                        </a-radio-button>  -->
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="电竞类型" v-show="query.type == 8">
                    <a-radio-group v-model="gameType" @change="onGameSearch()" button-style="solid">
                        <a-radio-button :value="8">
                            英雄联盟
                        </a-radio-button>
                        <a-radio-button :value="11">
                            CSGO
                        </a-radio-button>
                        <a-radio-button :value="9">
                            王者荣耀
                        </a-radio-button>
                        <a-radio-button :value="10">
                            Dota2
                        </a-radio-button>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="赛事时间">
                    <a-radio-group v-model="query.day" @change="onSearch" button-style="solid">
                        <a-radio-button v-for="item in dates" :key="item.key" :value="item.key">
                            {{ item.date }}
                        </a-radio-button>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="搜索">
                    <a-input-search :placeholder="$t('site.placeholder_search')" style="width: 400px"
                        @search="onSearchKeyword" />
                </a-form-model-item>
            </a-form-model>
            <a-spin :spinning="loading" style="margin-top: 16px;">
                <a-table bordered rowKey="tournament_id" :data-source="lists.data"
                    :pagination="{ total: lists.total, current: query.page, pageSize: 40, showTotal: (total) => `共 ${total} 条记录 `, }"
                    size="small" @change="onPageChange">
                    <!-- <a-table-column key="tournament_id" :title="$t('table.id')" data-index="tournament_id" v-if="debugMode">
                        <template slot-scope="text">
                            <span>
                                {{ text }}
                                <a-icon type="copy" v-clipboard:copy="text" v-clipboard:success="onCopy" />
                            </span>
                        </template>
                    </a-table-column> -->
                    <a-table-column key="league_name_zh" :title="$t('table.league')" data-index="league_name_zh">
                        <template slot-scope="text, record">
                            <a-tag :color="record.color"><span>{{ record | leagueName }}</span></a-tag>
                        </template>
                    </a-table-column>
                    <a-table-column key="match_time_int" :title="$t('table.matchtime')" data-index="match_time_int">
                        <template slot-scope="text">
                            <span>{{ text | dateFormat }}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="home_name_zh" :title="$t('table.hometeam')" data-index="home_name_zh">
                        <template slot-scope="text, record">
                            <span>{{ record | homeName }}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="away_team_zh" :title="$t('table.visitingteam')" data-index="away_team_zh">
                        <template slot-scope="text, record">
                            <span>{{ record | awayName }}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="faces" :title="$t('table.hosts')" data-index="faces" align="center"
                        v-if="minfo.type == 9">
                        <template slot-scope="text, record">
                            <a-space v-if="record.faces">
                                <a-avatar v-for="src in (record.faces || '').split(',')" :key="src" :src="src"
                                    :size="40">
                                </a-avatar>
                            </a-space>
                            <span v-else>暂无</span>
                        </template>
                    </a-table-column>
                    <a-table-column title="操作" key="action" align="center">
                        <template slot-scope="text, record">
                            <a-space>
                                <a-button v-if="minfo.type == 9" type="link" @click="openManageModal(record)">
                                    <!-- <a-badge :status="record.member_id ? 'success': 'default'" /> -->
                                    {{ $t('table.hostsmanage') }}
                                </a-button>
                                <span v-else-if="tournament_ids.includes(record.tournament_id)">
                                    <a-button type="link" @click="openModal(record)">{{ $t('table.update') }}</a-button>
                                    <a-popconfirm title="确定要下播吗？" @confirm="onCloseLive(record)">
                                        <a-button type="link" danger>{{ $t('table.remove') }}</a-button>
                                    </a-popconfirm>
                                </span>
                                <a-button v-else type="link" @click="openModal(record, 'add')">{{ $t('table.add') }}
                                </a-button>
                            </a-space>
                        </template>
                    </a-table-column>
                </a-table>
            </a-spin>
        </a-card>
        <a-modal :title="$t('modal.title')" v-model="modal.visible" @cancel="modal.visible = false" :width="600"
            class="modal">
            <a-form-model ref="form" :model="modal.formdata" :rules="modal.rules" :label-col="{ span: 4 }"
                :wrapper-col="{ span: 18 }">
                <a-form-model-item label="赛事信息">
                    <span>
                        <a-tag :color="modal.match.color"><span>{{ modal.match | leagueName }}</span></a-tag>
                    </span>
                    {{ modal.match | homeName }} VS {{ modal.match | awayName }}
                </a-form-model-item>
                <a-form-model-item label="赛事时间">
                    <span>{{ modal.match.match_time_int | dateFormat('MM月DD日 HH:mm') }}</span>
                </a-form-model-item>
                <a-form-model-item label="主播" prop="member_id" v-if="minfo.type == 9 && anchors.length > 0">
                    <a-select v-model="modal.formdata.member_id" placeholder="请选择主播" show-search
                        :filter-option="filterOption">
                        <a-select-option :value="anchor.member_id" v-for="anchor in anchors" :key="anchor.member_id">
                            {{ anchor.username }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="流id" prop="stream_key" v-if="modal.formdata.member_id == 133">
                    <a-input v-model="modal.formdata.stream_key" placeholder="请输入流id"></a-input>
                </a-form-model-item>
                <a-form-model-item label="开播平台" prop="channel_list">
                    <a-checkbox-group v-model="modal.formdata.channel_list">
                        <div v-if="query.type == 8" style="display: flex;">
                            <template v-for="channel in modal.channels">
                                <div v-if="channel.status == 1" style="margin-right: 10px" :key="channel.value">
                                    <a-checkbox :value="channel.value" :disabled="channel.disable == 1">
                                        {{ channel.name }}
                                    </a-checkbox>
                                </div>
                            </template>
                        </div>
                        <a-row :gutter="[12, 12]" v-else>
                            <a-col :span="8" v-for="channel in modal.channels" :key="channel.value">
                                <a-checkbox :value="channel.value" :disabled="channel.disable == 1">
                                    {{ channel.name }}
                                </a-checkbox>
                            </a-col>
                        </a-row>
                    </a-checkbox-group>
                </a-form-model-item>
            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="modal.visible = false"> 取消 </a-button>
                <a-button key="submit" type="primary" :loading="modal.loading" @click="onCreateLive">
                    <!--                    {{ modalManage.anchors.some((item => item.member_id == modal.formdata.member_id)) ? '修改' : '开播' }}-->
                    {{ modal.formdata.tvid ? '修改' : '开播' }}
                </a-button>
            </template>
        </a-modal>
        <a-modal title="主播管理" v-model="modalManage.visible" @cancel="modalManage.visible = false" :width="1000"
            class="modal">
            <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                <a-form-model-item label="赛事信息">
                    <span>
                        <a-tag :color="modalManage.match.color"><span>{{ modalManage.match | leagueName }}</span>
                        </a-tag>
                    </span>
                    {{ modalManage.match | homeName }} VS {{ modalManage.match | awayName }}
                </a-form-model-item>
                <a-form-model-item label="赛事时间">
                    <span>{{ modalManage.match.match_time_int | dateFormat('MM月DD日 HH:mm') }}</span>
                </a-form-model-item>
                <a-table rowKey="tournament_id" :data-source="modalManage.anchors" :pagination="false" size="small"
                    :scroll="{ x: 'max-content' }">
                    <a-table-column title="主播" key="username" :width="120" data-index="username" fixed="left">
                    </a-table-column>
                    <a-table-column title="开播平台" key="channels" data-index="channels">
                        <template slot-scope="text, record">
                            <div>
                                <a-form-model layout="inline" v-if="record.member_id == 133">
                                    <a-form-model-item label="流id： ">
                                        <a-input placeholder="请输入流id" v-model="record.stream_key"></a-input>
                                    </a-form-model-item>
                                </a-form-model>
                                <a-checkbox-group v-model="record.channel_list">
                                    <a-checkbox v-for="channel in record.channels" :key="channel.value"
                                        :value="channel.value" :disabled="channel.disable == 1">
                                        {{ channel.name }}
                                    </a-checkbox>
                                </a-checkbox-group>
                            </div>
                        </template>
                    </a-table-column>
                    <a-table-column title="操作" key="action" :width="140" align="center" fixed="right">
                        <template slot-scope="text, record">
                            <a-button type="link" size="small" @click="onUpdateLive(record)">{{ $t('table.update') }}
                            </a-button>
                            <a-popconfirm title="确定要下播吗？" @confirm="onCloseLive(record, 'manage')">
                                <a-button type="link" size="small">{{ $t('table.remove') }}</a-button>
                            </a-popconfirm>
                        </template>
                    </a-table-column>
                </a-table>
            </a-form-model>
            <template slot="footer">
                <a-button key="add" type="primary" style="float:left" @click="openModal(modalManage.match)"> 开播
                </a-button>
                <a-button key="back" @click="modalManage.visible = false"> 取消 </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import * as qiniu from "qiniu-js";
const font = "zh";

export default {
    data() {
        return {
            loading: false,
            dates: [],
            qiniuToken: '',
            previewVisible: false,
            previewImage: '',
            prefixUrl: '',
            liveBannerList: [],
            query: {
                page: 1,
                type: 0,
                day: moment().format("YYYYMMDD"),
                key_word: undefined
            },
            gameType: 8,
            lists: {
                data: [],
                total: 0,
            },
            tournaments: [],
            modal: {
                loading: false,
                match: {},
                channels: [],
                anchors: [],
                formdata: {
                    tournament_id: undefined,
                    tournament_type: undefined,
                    member_id: undefined,
                    stream_key: undefined,
                    channel_list: [],
                },
                rules: {
                    member_id: [{
                        required: true,
                        message: "请选择主播",
                        trigger: "change",
                    },],
                    stream_key: [{
                        required: true,
                        message: "请输入流id",
                        trigger: "blur",
                    },],
                    channel_list: [{
                        type: "array",
                        required: true,
                        message: "请选择开播平台",
                        trigger: "change",
                    },],
                },
                visible: false,
            },
            modalManage: {
                loading: false,
                match: {},
                anchors: [],
                visible: false,
            },
            timer: null,
            lastRefresh: "",

            filterOption(val, option) {
                return (
                    option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(val.toLowerCase()) >= 0
                );
            },
            livebanner: {
                loading: false
            },
            assistant: {
                loading: false,
                username: ''
            }
        };
    },
    computed: {
        ...mapState(["minfo", "anchors", "config"]),
        tournament_ids() {
            return this.tournaments.map((v) => v.tournament_id);
        },
    },
    filters: {
        dateFormat(val, formatter = "MM-DD HH:mm") {
            return moment(val * 1000).format(formatter);
        },
        leagueName(record) {
            return record[`league_name_${font}`] || record.league_name_zh;
        },
        homeName(record) {
            return record[`home_name_${font}`] || record.home_team_zh;
        },
        awayName(record) {
            return record[`away_name_${font}`] || record.away_team_zh;
        },
    },
    created() {
        // if (!this.$store.state.token) {
        //     return;
        // }
        const dates = [];
        const today = moment();
        for (let i = -1; i < 7; i++) {
            var d = today.clone().add("days", i);
            dates.push({
                key: d.format("YYYYMMDD"),
                week: d.format("dddd"),
                date: d.format("MM月DD日"),
            });
        }
        this.dates = dates;
        this.getMatchList();

        this.$store.subscribe((mutation, state) => {
            if (mutation.type == 'MEMBER') {
                this.assistant.username = state.minfo.chat_178 || ''
                if (state.minfo.cover_fix) {
                    this.liveBannerList = [{
                        name: state.minfo.cover_fix,
                        uid: state.minfo.cover_fix,
                        status: 'done',
                        url: state.minfo.cover_fix
                    }]
                }
            }
        })
        this.assistant.username = this.minfo.chat_178 || ''
        this.getQiniuToken()
    },
    methods: {
        onSearchKeyword(keywords) {
            this.query.key_word = keywords
            this.onSearch()
        },
        async onSearch() {
            this.query.page = 1;
            this.$nextTick(() => {
                this.getMatchList();
            });
        },
        async onGameSearch() {
            this.query.page = 1;
            this.$nextTick(() => {
                this.getMatchList();
            });
        },

        async getMatchList() {
            this.modal.visible = false;
            this.loading = true;
            let { type, day, page, key_word } = this.query;
            let url = "";
            if (type == 0) {
                url = "/stream/football_list";
            } else if (type == 1) {
                url = "/stream/basketball_list";
            } else if (type == 8) {
                if (this.gameType == 8) {
                    url = "/stream/lol_list";
                } else if (this.gameType == 9) {
                    url = "/stream/kog_list";
                } else if (this.gameType == 10) {
                    url = "/stream/dota2_list";
                } else if (this.gameType == 11) {
                    url = "/stream/csgo_list";
                }
            }
            const response = await this.$api.get(url, {
                params: { day, page, key_word },
            });
            if (response.code == 200) {
                response.data = response.data || [];
                this.lists = response.data;
                if (this.minfo.type == 2) {
                    this.getLives();
                }
                this.lastRefresh = moment().format("HH:mm:ss");
                this.timer && clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.getMatchList();
                }, 305000);
            }
            this.$nextTick(() => {
                this.loading = false;
            });
        },
        onPageChange(pagination) {
            this.query.page = pagination.current;
            this.getMatchList();
        },
        async openManageModal(record) {
            this.modalManage.match = record;
            const response = await this.$api.get(
                `/stream/anchors/${record.tournament_id}`
            );
            if (response.code == 200) {
                this.modalManage.anchors = (response.data.live_list || []).map(
                    (item) => {
                        if (item.channels && Array.isArray(item.channels)) {

                        } else {
                            item.channels = [];
                            for (let index = 0; index < 10; index++) {
                                if (index in item) {
                                    item.channels.push(item[index]);
                                }
                            }
                        }
                        item.stream_key = item.stream_key || item.stream_id;
                        item.channel_list = item.channels
                            .filter((v) => v.status == 1)
                            .map((v) => v.value);
                        return item;
                    }
                );
            }
            this.modalManage.visible = true;
        },
        async openModal(record) {
            this.modal.match = record;
            const response = await this.$api.get("/stream/detail", {
                params: { tournament_id: record.tournament_id },
            });
            console.info('openModal', record)
            if (response.code == 200) {
                const { id, member_id, channel_list } = response.data || {};
                this.modal.formdata = {
                    tvid: (member_id && member_id == 133) ? null : id,
                    tournament_id: record.tournament_id,
                    tournament_type: this.query.type == 8 ? this.gameType : this.query.type,
                    member_id: undefined,
                    channel_list: channel_list
                        .filter((v) => v.status == 1)
                        .map((v) => v.value),
                    stream_key: undefined,
                };
                this.modal.channels = channel_list;
                this.modal.visible = true;
            }
        },
        async onCreateLive() {
            await this.$refs.form.validate()
            const { tvid, ...odata } = this.modal.formdata;
            this.modal.loading = true;
            if (odata.member_id == 133) {
                if (!odata.stream_key) {
                    this.$message.error("请输入流id");
                    return;
                }
            } else {
                odata.stream_key = undefined;
            }

            let response = null;
            if (tvid) {
                response = await this.$api
                    .post(`/stream/update/${tvid}`, odata)
                    .catch((e) => {
                        this.modal.loading = false;
                    });
            } else {
                response = await this.$api
                    .post("/stream/add", odata)
                    .catch((e) => {
                        this.modal.loading = false;
                    });
            }
            if (response.code == 200) {
                this.getLives();
                this.getMatchList();
                this.$message.success(response.msg);
                this.modal.visible = false;
            }
            this.$nextTick(() => {
                this.modal.loading = false;
            });
            if (this.minfo.type == 9) {
                this.openManageModal(this.modal.match);
            }
        },
        async onUpdateLive(record) {
            const { tournament_id } = this.modalManage.match;
            const { channel_list, member_id, tvid, stream_key } = record;

            if (tvid) {
                const data = {
                    member_id,
                    channel_list,
                    tournament_id,
                    tournament_type: this.query.type,
                };
                if (data.member_id == 133) {
                    if (!stream_key) {
                        this.$message.error("请输入流id");
                        return;
                    }
                    data.stream_key = stream_key;
                }
                const response = await this.$api.post(
                    `/stream/update/${tvid}`,
                    data
                );
                if (response.code == 200) {
                    this.openManageModal(this.modalManage.match);
                    this.$message.success(response.msg);
                }
            }
        },
        async onCloseLive(record, type = "add") {
            let response = null;
            if (type == "manage") {
                response = await this.$api
                    .post(`/stream/close/${record.tvid}`, {
                        member_id: record.member_id,
                    })
                    .catch((e) => {
                        console.warn("e", e);
                    });
                if (response.code == 200) {
                    this.getMatchList();
                    this.openManageModal(this.modalManage.match);
                    this.$message.success(response.msg);
                }
            } else if (type == "add") {
                const live = this.tournaments.find(
                    (v) => v.tournament_id == record.tournament_id
                );
                response = await this.$api.post(`/stream/close/${live.id}`);
                if (response.code == 200) {
                    this.getMatchList();
                    this.getLives();
                    this.$message.success(response.msg);
                    this.modal.visible = false;
                }
            }
        },
        async getLives() {
            const response = await this.$api.get("/stream/live");
            if (response.code == 200) {
                this.tournaments = response.data || [];
            }
        },
        onCopy() {
            this.$message.success(this.$t("table.copytips"));
        },
        async onUploadKey() {
            this.$confirm({
                title: '确认要更新推流密钥吗?',
                content: '更新后原密钥将失效，慎重操作！',
                onOk: async () => {
                    const response = await this.$api.post(`/stream/new_stream`);
                    if (response.code == 200) {
                        this.$store.dispatch('getConfig');
                        this.$message.success('更新成功')
                    } else {
                        this.$message.error(response.msg || '更新失败')
                    }
                }
            });
        },
        async onSaveAssistant() {
            this.assistant.loading = true
            const response = await this.$api.post(`/set_178_chat`, { username_178: this.assistant.username || 0 }).catch(() => this.assistant.loading = false)
            if (response.code == 200) {
                this.$store.dispatch('getMemberInfo');
                this.$message.success('更新成功')
            }
            this.assistant.loading = false
        },
        async getQiniuToken() {
            const res = await this.$api.get(`/qiniu/token`)
            if (res.code == 200) {
                this.qiniuToken = res.data.token
                this.prefixUrl = res.data.url
            }
            console.log(res)
        },
        async onSaveLiveBanner() {
            this.livebanner.loading = true
            const imgUrl = this.liveBannerList.length > 0 ? this.liveBannerList[0].url : ''
            const response = await this.$api.post(`/update_user`, { cover_fix: imgUrl }).catch(() => this.assistant.loading = false)
            if (response.code == 200) {
                this.$store.dispatch('getMemberInfo');
                this.$message.success('更新成功')
            }
            this.livebanner.loading = false
        },
        imgUpload(data) {
            console.log(data)
            if (!['image/jpg', 'image/jpeg', 'image/png', 'image/PNG'].includes(data.file.type)) {
                this.$message.error('封面图只允许上传小于4M的图片(格式：jpg/jpeg/png)')
                this.liveBannerList = []
                return false
            }
            const token = this.qiniuToken
            const fname = data.file.name
            const imgType = fname.split(".")[fname.split(".").length - 1]
            const time = new Date().getTime() + Math.floor(Math.random() * 1000)
            const key = 'live/poster/' + time + '.' + imgType
            const putExtra = {
                fname: fname,
                params: {},
                mimeType: ["image/png", "image/jpeg", "image/jpg", "image/PNG"],
            }
            const config = {
                useCdnDomain: true,
            }
            const that = this
            var observer = {
                next(res) {
                },
                error(err) {
                    alert("封面图只允许上传小于4M的图片(格式：jpg/jpeg/png)");
                },
                complete(res) {
                    console.log(res)
                    that.liveBannerList = [
                        {
                            uid: res.hash,
                            status: 'done',
                            name: res.hash,
                            url: that.prefixUrl + res.key
                        }
                    ]
                },
            };
            const observable = qiniu.upload(data.file, key, token, putExtra, config)
            observable.subscribe(observer)
        },
        fileChange(files) {
            // if () {}
        },
        imgRemove(file) {
            console.log(file)
            this.liveBannerList = []
        },
        beforeUpload(file) {
            this.liveBannerList = [file]
            return false
        },
        handleCancel() {
            this.previewVisible = false;
        },
        async handlePreview(file) {
            this.previewImage = file.url;
            this.previewVisible = true;
        },
    },
};
</script>
<style lang="less">
.dates {
    display: flex;
    align-items: center;
    border: 1px solid #e8e8e8;

    .date {
        padding: 8px 10px;
        text-align: center;
        cursor: pointer;

        &+.date {
            border-left: 1px solid #e8e8e8;
        }

        &.active {
            color: #fff;
            background-color: #1890ff;
        }
    }

    &.types {
        .date {
            line-height: 42px;
            padding: 8px 24px;
        }
    }
}

.drawer-action {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    height: 50px;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    padding: 0 40px;
    box-shadow: 0px -5px 10px #999999;
}

.ant-form-item {
    margin-bottom: 16px;
}

.modal {
    .ant-modal-header {
        background-color: #1890ff;

        .ant-modal-title {
            color: #fff;
        }
    }

    .anticon-close {
        color: #fff;

        svg {
            fill: #ffffff;
        }
    }
}
</style>
